export default __webpack_public_path__ + "static/media/signpost-4.9259f93f.png";